import { getLocale } from "../runtime";

const sv_limitedstock = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Begränsat antal i lager`
};

const limitedstock = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_limitedstock(inputs)
	return "limitedStock";
};

export { limitedstock as "limitedStock" };